module.exports = __webpack_public_path__ + "img/exit.545180b8.png";